import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { SharedService } from "src/app/shared-modules/shared.service";
import { CustomerServiceService } from "../customer-service.service";
import { LoginComponent } from "src/app/shared-modules/login/login.component";

@Component({
  selector: "app-customer-header",
  templateUrl: "./customer-header.component.html",
  styleUrls: ["./customer-header.component.css"],
})
export class CustomerHeaderComponent implements OnInit {
  @Input() profileDetails = "";

  token: any;
  userName: any;
  profilePic: any;
  constructor(
    private router: Router,
    private services: CustomerServiceService,
    private snackBar: MatSnackBar,
    private shrdSrvce: SharedService,
    private matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.GetProfileDetails();
    this.profile();
    this.shrdSrvce.authState$.subscribe(() => {
      this.GetProfileDetails();
      this.profile();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["profileDetails"] && changes["profileDetails"].currentValue === "success") {
      this.GetProfileDetails();
    }
  }

  public GetProfileDetails() {
    this.token = sessionStorage.getItem("token");
    this.userName = sessionStorage.getItem("userName");
    this.profilePic = sessionStorage.getItem("ProfilePic");
  }

  profile() {
    let token = sessionStorage.getItem("token");
    if (!token) return;
    this.services.GetProfile(token).subscribe((response: any) => {
      sessionStorage.removeItem("userName");
      this.userName = response.body.data.username;
      sessionStorage.setItem("userName", response.body.data.username);
    });
  }

  login() {
    const dialogRef = this.matDialog.open(LoginComponent, {
      width: "500px",
      data: {
        routeFrom: "header",
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.GetProfileDetails();
      this.profile();
    });
  }

  logout() {
    // localStorage.clear();
    
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("ProfilePic");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("searchData");
    sessionStorage.removeItem("search_details");
    sessionStorage.removeItem("quoteBooked");
    this.shrdSrvce.updateSearchDetails(null);
    this.services.customerLogout(this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.router.navigateByUrl("/");
          this.snackBar.open("Account logout successfully", "Success", {
            duration: 3000,
          });
        }
      },
      (error) => {
        // localStorage.clear();
        sessionStorage.removeItem("userName");
        sessionStorage.removeItem("ProfilePic");
        sessionStorage.removeItem("token");
        this.router.navigateByUrl("/");
      }
    );
  }

  GoToProfile() {
    this.router.navigateByUrl("/profile");
  }
  trips() {
    this.router.navigateByUrl("/trips");
  }

  GoToDashboard() {
    this.router.navigateByUrl("/dashboard");
  }
}
